/* eslint-disable*/
import VueStoreService from './VueStoreService';
const VehicleService = {
  //VEHICULOS
  async getAutoPartsVehicle(url, store) {
    var resp = await VueStoreService.get("car-brand" + url, store)
    return resp;
  },
  async getVehicleById(vehicle_id, store) {
    var resp = await VueStoreService.get("car-brand/" + vehicle_id, store)
    return resp;
  },  
  async saveAutoPartVehicle(data, store) {
    var resp = await VueStoreService.post("car-brand", data, store)
    return resp;
  },
  async updateAutoPartVehicle(vehicle_id, data, store) {
    var resp = await VueStoreService.patch("car-brand/" + vehicle_id, data, store)
    return resp;
  },
  async deleteAutoPartVehicle(vehicle_id, store) {
    var resp = await VueStoreService.delete("car-brand/" + vehicle_id, store)
    return resp;
  },
  //MODELOS
  async getModels(url, store) {
    var resp = await VueStoreService.get("car-model"+ url, store)
    return resp;
  },
  async saveModel(data, store) {
    var resp = await VueStoreService.post("car-model", data, store)
    return resp;
  },
  async updateModel(model_id, data, store) {
    var resp = await VueStoreService.patch("car-model/" + model_id, data, store)
    return resp;
  },
  async getModelsxVehicle(vehicle_id, store) {
    var resp = await VueStoreService.get("car-model/" + vehicle_id, store)
    return resp;
  },
  
  async deleteModel(model_id, store) {
    var resp = await VueStoreService.delete("car-model/" + model_id, store)
    return resp;
  },
}

export default VehicleService;